import React from 'react';
import PropTypes from 'prop-types';
import { Maximize } from 'react-feather';
import { UncontrolledTooltip } from 'reactstrap';

export function goFull() {
  if ((document.fullScreenElement && document.fullScreenElement !== null)
    || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
    if (document.documentElement.requestFullScreen) {
      document.documentElement.requestFullScreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullScreen) {
      document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  } else if (document.cancelFullScreen) {
    document.cancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  }
}

function MaximizeBrowserButton({ id, title }) {
  function allowBrowserMaximize() {
    return (
      document.documentElement.requestFullScreen
      || document.documentElement.mozRequestFullScreen
      || document.documentElement.webkitRequestFullScreen
    );
  }
  // full screen function
  return (
    allowBrowserMaximize
      ? (
        <>
          <UncontrolledTooltip placement="top" target={id}>
            {title}
          </UncontrolledTooltip>
          <a id={id} onClick={goFull} className="text-dark" href="#!">
            <Maximize />
          </a>
        </>
      )
      : null
  );
}

MaximizeBrowserButton.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default MaximizeBrowserButton;
